export const track = ({ eventName }) => {
  if (!window.hj) {
    return
  }

  window.hj('event', `AMS-${eventName}`)
}
